import * as _ from 'lodash'
import React from 'react';
import util from '../util';
import validator from '../validator';
import valueFilters from '../valueFilters';
import enums from '../enum';
import { PhoneInput } from './sharedComponents';

export class ContactEditCore extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = {
			otherPhoneType: enums.phoneNumberTypes.Mobile
		};

		this.handleOtherPhoneTypeChange = this.handleOtherPhoneTypeChange.bind(this);
	}

	handleOtherPhoneTypeChange (e) {
		const { disabled, readOnly } = this.props;

		e.preventDefault();
		if (disabled || readOnly) { return; }

		const newVal = Number(e.target.value);
		// const otherPhone = this.props.contact.getPhoneNumberByType(newVal);

		this.updateState(nextState => {
			nextState.otherPhoneType = newVal;
		});
	}

	updateState (updater) {
		this.setState(previousState => {
			const nextState = _.assign({}, previousState);

			updater(nextState);

			return nextState;
		});
	}

	updatePhone (phoneType, autoSave, e) {
		const { disabled, readOnly } = this.props;

		if (disabled || readOnly) { return; }

		const viewValue = e.target.value;

		this.props.updateModel(model => {
			model.setPhoneNumber(phoneType, viewValue);
		}, { autoSave: autoSave });
	}

	validate (property) {
		const { disabled, readOnly } = this.props;

		if (disabled || readOnly) { return true; }

		return this.props.validate(this.props.contact, property);
	}

	updateModel (path, autoSave, e) {
		const { disabled, readOnly } = this.props;
		e.preventDefault();

		if (disabled || readOnly) { return; }

		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	render () {
		const { contact } = this.props;
		const preferredContactOptions = _.map(enums.contactMethods.getItems(), cm => {
			return (<option key={ 'pc_' + cm.value } value={cm.value}>{enums.contactMethods.getDisplayName(cm.value) || 'Select'}</option>);
		});
		const otherPhoneOptions = [
			<option value={enums.phoneNumberTypes.Mobile} key="mobilePhoneOption">Mobile Phone</option>,
			<option value={enums.phoneNumberTypes.Home} key="homePhoneOption">Home Phone</option>
		];

		const otherPhone = contact.getPhoneNumberByType(this.state.otherPhoneType);
		const otherPhoneNumber = otherPhone ? otherPhone.number : '';

		return (
			<React.Fragment>
				<table className="half" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr className={!this.validate('firstName') ? 'required' : ''}>
							<td />
							<td><strong>First Name</strong></td>
							<td><input type="text" className="" placeholder="First Name" autoCapitalize="" autoCorrect="off" value={contact.viewValue('firstName')} onChange={this.updateModel.bind(this, 'firstName', false)} onBlur={this.updateModel.bind(this, 'firstName', true)} /></td>
							<td />
						</tr>
						<tr className={!this.validate('lastName') ? 'required' : ''}>
							<td />
							<td><strong>Last Name</strong></td>
							<td><input type="text" placeholder="Last Name" autoCapitalize="" autoCorrect="off" value={contact.viewValue('lastName')} onChange={this.updateModel.bind(this, 'lastName', false)} onBlur={this.updateModel.bind(this, 'lastName', true)} /></td>
							<td />
						</tr>
						<tr className={!this.validate('preferredContactMethod') ? 'required' : ''}>
							<td />
							<td><strong>Preferred Contact Method</strong></td>
							<td>
								<select value={contact.viewValue('preferredContactMethod')} onChange={this.updateModel.bind(this, 'preferredContactMethod', true)}>
									{preferredContactOptions}
								</select>
							</td>
							<td />
						</tr>
						<tr className={!this.validate('title') ? 'required' : ''}>
							<td />
							<td><strong>Title</strong></td>
							<td><input type="text" placeholder="Title" autoCapitalize="" autoCorrect="off" value={contact.viewValue('title')} onChange={this.updateModel.bind(this, 'title', false)} onBlur={this.updateModel.bind(this, 'title', true)} /></td>
							<td />
						</tr>
					</tbody>
				</table>
				<table className="half" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr className={!this.validate('emailAddress') ? 'required' : ''}>
							<td />
							<td><strong>Email Address</strong></td>
							<td><input type="text" placeholder="" autoCapitalize="" autoCorrect="off" value={contact.viewValue('emailAddress')} onChange={this.updateModel.bind(this, 'emailAddress', false)} onBlur={this.updateModel.bind(this, 'emailAddress', true)} /></td>
							<td />
						</tr>
						<tr className={(!!contact.workPhoneNumber && !validator.isPhone(contact.workPhoneNumber)) ? 'required' : ''} >
							<td />
							<td><strong>Office Phone</strong></td>
							<td><PhoneInput placeholder="" autoCapitalize="" autoCorrect="off" value={contact.viewValue('workPhoneNumber')} onChange={this.updatePhone.bind(this, enums.phoneNumberTypes.Work, false)} onBlur={this.updatePhone.bind(this, enums.phoneNumberTypes.Work, true)} /></td>
							<td />
						</tr>
						<tr className={(!!otherPhone && !validator.isPhone(otherPhoneNumber)) ? 'required' : ''}>
							<td />
							<td>
								<select className="label" value={util.reactVal(this.state.otherPhoneType)} onChange={this.handleOtherPhoneTypeChange}>
									{otherPhoneOptions}
								</select>
							</td>
							<td><PhoneInput placeholder="" autoCapitalize="" autoCorrect="off" value={ otherPhoneNumber } onChange={this.updatePhone.bind(this, this.state.otherPhoneType, false)} onBlur={this.updatePhone.bind(this, this.state.otherPhoneType, true)} /></td>
							<td />
						</tr>
					</tbody>
				</table>
			</React.Fragment>
		);
	}
}

export default function ContactEdit (props) {
	const { disabled, hideHeader, readOnly, title } = props;
	const classNames:string[] = [];

	if (disabled) {
		classNames.push('disabled');
	}

	if (readOnly) {
		classNames.push('readOnly');
	}

	return (
		<section>
			{ hideHeader ? null : <header><span>{ title || 'CONTACT' }</span></header> }
			<div className={ classNames.join(' ') }>
				<ContactEditCore { ...props} />
			</div>
		</section>
	);
}